import React, { useContext, useMemo, useState } from 'react'
import { dateCol, intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import {
  deleteBidOffer,
  getAuthorization,
  getPjmAdminBidOffer,
  getCredentials,
  importBidOfferAutoImport,
  updateBidOffer,
} from '../api/pgads'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
} from 'core'
import { connect } from 'react-redux'
import {
  Button,
  DatePicker,
  Icon,
  Input,
  InputNumber,
  message,
  Upload,
} from 'antd'
import {
  DatePickerContext,
  PNodeZoneContext,
  ErrorContext,
  SpinContext,
  JcTmpErrorContext,
} from 'context'
import { unitIdHeader } from 'core/HeaderColTypeProps'
import MarginAnalysisUtilityUnitSelection from '../marginanalysis/MarginAnalysisUtilityUnitSelection'
import { Label } from 'core/screen-util'
import * as ScreenPermissions from 'core/EventActions'

import { hasAccesPermits } from 'core/utils'
import { CriteriaRow } from '../core/screen-util'

const title = 'Bid Offer'

const BidOffer = ({ targetInfo, envConfig, actionPermits }) => {
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const { selectedDate } = useContext(DatePickerContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  // eslint-disable-next-line no-unused-vars
  const [insertEvent, setInsertEvent] = useState(false)
  const {
    unitIdEmktIdMap,
    emktIdUnitNameMap,
    marginUnitsList,
    // emktUnits,
  } = useContext(PNodeZoneContext)

  const withCriteria = (state, props, selectedUnits = []) => ({
    unitid: selectedUnits.map(u => u.unitId).map(id => unitIdEmktIdMap[id]),
    startdate: selectedDate,
    enddate: selectedDate,
  })

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  const headerWithFormatter = OaBidOfferHeaders.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  // const manualImport = _ => {
  //   importBidOfferTest(targetInfo).fork(setError, _ => _)
  // }

  const importPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CHANGE_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const fileProps = {
    name: 'file',
    action: `${targetInfo.baseUrl}/pjm-admin/import-bidoffer-manual`,
    method: 'POST',
    data: {},
    headers: getAuthorization(targetInfo),
    ...getCredentials(targetInfo),
  }

  const autoIsoImport = _ => {
    setSpinning(true)
    importBidOfferAutoImport(targetInfo)(selectedDate).fork(
      setError,
      tmpError => {
        setSpinning(false)
        setTmpError(tmpError)
      }
    )
  }

  const extraCriteriaAfterButton = () => {
    return (
      <CriteriaRow
        style={{ padding: '0px', paddingBottom: '5px', justifyContent: 'end' }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '150px 150px',
            columnGap: '20px',
            border: '0px solid black',
            padding: '2px',
            marginLeft: '100px',
          }}
        >
          <Upload
            {...fileProps}
            beforeUpload={_ => setSpinning(true)}
            onChange={data => {
              setSpinning(false)
              if (
                data.file.response &&
                data.file.response.restfulStatus &&
                data.file.response.restfulStatus === 'FAILURE'
              ) {
                // setShowMessages(true)
                // setMessages([data.file.response])
                setError(data.file.response)
              } else if (
                data.file.response &&
                data.file.response.length === 0
              ) {
                //  if (data.file.response) {
                message.success('File imported successfully')
                // }
              } else if (data.file.response && data.file.response.length > 0) {
                setTmpError(data.file.response)
                //  if (data.file.response) {
                // message.success('File imported successfully')
                // }
              }
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button disabled={!importPermission} type="primary">
              <Icon type="upload" /> Manual CSV Import
            </Button>
          </Upload>

          {/* <Button onClick={manualImport}>Manual CSV Import</Button> */}
          <Button
            type="danger"
            onClick={autoIsoImport}
            disabled={!importPermission}
            style={{ marginLeft: '10px' }}
          >
            Auto ISO Import
          </Button>
        </div>
      </CriteriaRow>
    )
  }

  return (
    <CommonScreen
      // extraCriteriaAfterButton={extraCriteriaAfterButton}
      extraCriteria={extraCriteriaAfterButton}
      extraUnitSelectionProps={extraUnitSelectionProps}
      withDatePicker
      withCriteria={withCriteria}
      withUnitSelection
      title={title}
      header={headerWithFormatter}
      retrieveTask={getPjmAdminBidOffer}
      deleteTask={deleteBidOffer}
      saveTask={updateBidOffer}
      altBy={d => d.unitid}
      autoRetrieve={false}
      sortOptions={OaBidOfferHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={
        insertEvent && importPermission
          ? pr => (
              <BidOfferInsertComponent
                {...pr}
                unitIdEmktIdMap={unitIdEmktIdMap}
              />
            )
          : false
      }
      insertCompHeight={insertEvent ? 90 : 0}
      onInsertEvent={b => setInsertEvent(importPermission && b)}
    />
  )
}

export const BidOfferInsertComponent = ({
  insertData,
  setInsertData,
  onAdd,
  onCancel,
  unitIdEmktIdMap,
}) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns:
          '100px 100px 150px 200px 100px 150px 120px 100px 100px',
        gap: '5px',
      }}
    >
      <Label>Unit:</Label>
      <div style={{ gridColumn: 'span 3' }}>
        <MarginAnalysisUtilityUnitSelection
          utility={insertData.utility || null}
          unit={insertData.unit || null}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unit: value[1],
              unitId: unitIdEmktIdMap[value[1]],
            })
          }}
          style={{ width: '100%' }}
        />
      </div>
      <Label>Schedule :</Label>
      <InputNumber
        value={insertData.schedule}
        onChange={schedule => setInsertData({ ...insertData, schedule })}
      />
      <Label>Transaction Date :</Label>
      <DatePicker
        allowClear={false}
        format="MM/DD/YYYY"
        value={insertData.transdateObj}
        onChange={date => {
          setInsertData({
            ...insertData,
            transdate: date.format('YYYY-MM-DD'),
            transdateObj: date,
          })
        }}
        style={{ width: '100%', gridColumnEnd: 'span 2' }}
      />
      <Label>Use Bid Slope :</Label>
      <Input
        value={insertData.slope}
        onChange={e => setInsertData({ ...insertData, slope: e.target.value })}
      />
      <Label>Segment EndMW :</Label>
      <InputNumber
        value={insertData.mw}
        onChange={mw => setInsertData({ ...insertData, mw })}
      />
      <Label>Offer Price :</Label>
      <InputNumber
        value={insertData.price}
        onChange={price => setInsertData({ ...insertData, price })}
      />
      <div
        style={{
          gridColumn: 'span 2',
          gridRowGap: '10px',
          width: '100%',
          display: 'grid',
          gridTemplateColumns: 'auto auto auto',
          paddingLeft: '5px',
          gridColumnGap: '10px',
        }}
      >
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(BidOffer)

export const OaBidOfferHeaders = [
  // strCol({ ident: 'companyId', display: 'CompanyId', isFiltered: true }),
  // strCol({ ident: 'unitid', display: 'Unit', isKey: true }),
  unitIdHeader,
  dateCol({
    ident: 'transdate',
    display: 'Transaction Date',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),

  intCol({
    ident: 'schedule',
    display: 'Schedule',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'slope',
    display: 'Use Bid Slope',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'mw',
    display: 'Segment EndMW',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'price',
    display: 'Offer Price',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'modifier',
    display: 'Modifier',
    showInRowEditor: false,
    type: 'str',
    width: 130,
    isKey: true,
  }),
  {
    ident: 'modifiedDate',
    display: 'Modified Date',
    width: 200,
    showInRowEditor: false,
    dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
    displayFormat: 'MM/DD/YYYY HH:mm:SS',
    type: 'date-time',
    isKey: true,
  },
]
